module.exports = __webpack_public_path__ + "static/img/bcg.e8ad1df3.jpg";